exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-skeleton-js": () => import("./../../../src/templates/Skeleton.js" /* webpackChunkName: "component---src-templates-skeleton-js" */)
}

